import React from 'react';
import { Tag } from '@teetsh/app/src/components/Tag';
import { ILivretStatus } from '@teetsh/app/src/containers/Livrets/types/livret';
import { useTranslation } from 'react-i18next';

interface Props {
  status: ILivretStatus;
}

export function LivretStatus(props: Props) {
  const { t } = useTranslation(['carnet']);
  const { status } = props;
  if (status === 'done') {
    return <Tag color="green">{t('carnet:livret.done')}</Tag>;
  }
  if (status === 'draft') {
    return <Tag color="yellow">{t('carnet:livret.draft')}</Tag>;
  }
  if (status === 'not_started') {
    return <Tag color="gray">{t('carnet:livret.notStarted')}</Tag>;
  }
  return null;
}
